import { Button, Card, Input } from '@bienenkampf/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { eventSocket } from '../hooks/useGameEvents.js';
import { useTRPC } from '../lib/trpc.js';

export function AuthPage({ mode }: { mode: 'login' | 'register' }) {
  const trpc = useTRPC();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const opts = {
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: trpc.auth.me.queryKey() });
      eventSocket.reconnect();
      await navigate({ to: '/' });
    },
  };
  const login = useMutation(trpc.auth.login.mutationOptions(opts));
  const register = useMutation(trpc.auth.register.mutationOptions(opts));
  const m = mode === 'login' ? login : register;

  const submit = (e: FormEvent) => {
    e.preventDefault();
    m.mutate({ email, password });
  };

  return (
    <div className="mx-auto w-full max-w-sm py-8">
      <Card title={mode === 'login' ? 'Anmelden' : 'Konto anlegen'}>
        <form className="flex flex-col gap-3" onSubmit={submit}>
          <Input
            label="E-Mail"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label="Passwort"
            name="password"
            type="password"
            autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {m.error && <p className="text-sm text-red-400">{m.error.message}</p>}
          <Button type="submit" loading={m.isPending}>
            {mode === 'login' ? 'Anmelden' : 'Registrieren'}
          </Button>
        </form>
        <p className="mt-4 text-sm text-stone-400">
          {mode === 'login' ? (
            <>
              Noch kein Konto?{' '}
              <Link to="/register" className="text-amber-400">
                Registrieren
              </Link>
            </>
          ) : (
            <>
              Schon registriert?{' '}
              <Link to="/login" className="text-amber-400">
                Anmelden
              </Link>
            </>
          )}
        </p>
      </Card>
    </div>
  );
}
